import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageService } from '@ex/module/core/services/language.service';
import { LocalService } from '@ex/module/core/services/local.service';
import { ZenSnackbarService } from '@ex/module/shared/Theme/services/zen-snackbar.service';
import { ModuleName } from '@ex/module/shared/enums/ModuleName';
import { LanguagePipe } from '@ex/module/shared/pipes/language.pipe';
import { TranslatePipe } from '@ex/module/shared/pipes/translate.pipe';
import { GenerateLinkService } from '@ex/survey-x/index';

import { Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
declare var $: any;
@Component({
  selector: 'app-surveyx-landing',
  templateUrl: './surveyx-landing.component.html',
  styleUrls: ['./surveyx-landing.component.scss'],
})
export class SurveyxLandingComponent implements OnInit {


  userSubscription: Subscription;
  language: string = 'EN';
  logoLoading: boolean = false;
  tenantLogo: string;
  base64Image: string;
  logoURL: string = 'assets/img/svg/logo.svg';
  tenantKeyExists: boolean = false;
  section: string = 'login';
  hide = true;
  showLangage: boolean = false;
  returnUrl: string;
  emailPattern = '^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$';
  ModuleNames = ModuleName

  form = {
    id: '',
    name: '',
    email: '',
  };
  valid = true;

  supportedLanguages: any = [];
  tenantKey: string;
  engagementKey: string;
  referenceKey: string;

  displayLoader: boolean = false;


  private subscriptions = new Subscription();

  constructor(private route: ActivatedRoute, private translationPipe: TranslatePipe, private languagePipe: LanguagePipe,
    private languageService: LanguageService,
    private localService: LocalService, private generateLinkService: GenerateLinkService,
    private router: Router, private zenSnackBarService: ZenSnackbarService) {
  }




  ngOnInit(): void {
    this.canvasStart()
    this.referenceKey = this.route.snapshot.paramMap.get('refKey');

    if (this.referenceKey) {
      localStorage.setItem('LandingKey', this.referenceKey);

      this.supportedLanguages = this.languageService.supportedLanguages.filter(s => (s.key == 'EN' || s.key == 'AR'));

      this.logoURL = 'assets/img/svg/logo.svg'; // to be resolved to client's logo

      this.SetupLanguage();

      this.isArabic();

      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    }
  }



  onSubmit() {
    this.form.id = this.form.id?.trim() ?? '';
    this.form.name = this.form.name?.trim() ?? '';
    this.form.email = this.form.email?.trim() ?? '';

    if (!this.form.name || !this.form.email) {
      this.valid = false;
      return;
    }

    if (this.form.email && !new RegExp(this.emailPattern).test(this.form.email)) {
      this.valid = false;
      return;
    }

    this.valid = true;

    this.displayLoader = true;
    this.subscriptions.add(this.generateLinkService.createRespondent(this.referenceKey, {
      respondentEmail: this.form.email,
      name: this.form.name,
      employeeId: this.form.id
    })
      .pipe(catchError(err => {
        console.log(err);
        throw err;
      }))
      .subscribe((response: any) => {
        if (response.url) {
          this.router.navigate(['/survey-x-questionnaire/' + response.token]);
          this.displayLoader = false;
        }
      }, (error) => {

        console.log(error);
        this.zenSnackBarService.error("Try again later" + error?.error?.error?.message);
        this.displayLoader = false;
      }));

  }
  extractNameLanguage(eG: any) {
    return this.languageService.extractNameLanguage(eG, this.language);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  canvasStart() {
    var canvas = <HTMLCanvasElement>document.getElementById('c');
    var ctx = canvas.getContext('2d');
    let colors = ['#fbfbfb', '#f7f7f8', '#f4f4f4', '#f0f0f1', '#ededee', '#e9e9ea']
    canvas.height = window.innerHeight;
    canvas.width = window.innerWidth;
    let speed = 1;

    function animate() {
      requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let color = 0; color < colors.length; color++) {
        ctx.beginPath();
        ctx.moveTo(-200, (canvas.height / 10 + Math.sin(speed * .01) * 200) + color * 100 + color * 100 / 2);
        ctx.bezierCurveTo(
          canvas.width / 2,
          (canvas.height / 4 + Math.cos(speed * .01) * 200) + color * 100 + color * 100 / 2,
          canvas.width / 4,
          (canvas.height / 4 + Math.sin(-speed * .01) * 200) + color * 100 + color * 100 / 2,
          canvas.width + 200,
          (canvas.height / 3 + Math.sin(-speed * .01) * 200) + color * 100 + color * 100 / 2);
        ctx.lineWidth = 130 + color * 100 / 2;
        ctx.strokeStyle = colors[color];
        ctx.stroke();
      }
      speed += .5;
    }

    animate();
  }

  closeDropdown(menu) {
    if (this[menu]) this[menu] = false;
  }

  selectedLanguageChange(event) {
    this.language = event;
    this.localService.setJsonValue('language', this.language);
    this.isArabic()
  }

  isArabic() {
    if (this.languagePipe.transform(this.language)) {
      $("body").removeClass('ltr')
      $("body").addClass('rtl').attr("dir", "rtl")

    }
    else {
      $("body").removeClass('rtl')
      $("body").addClass('ltr').attr("dir", "ltr")

    }
  }

  private SetupLanguage() {
    let localLanguage = this.localService.getJsonValue('language');
    let sessionLanguage = this.localService.getJsonValue('language');

    if (!localLanguage && !sessionLanguage) {
      this.language = 'EN';
    }
    else if (localLanguage) {
      this.language = localLanguage;
    }
    else if (sessionLanguage) {
      this.language = sessionLanguage;
    }

    this.languageService.language = this.language;
  }

}
